const FormularioUtils = {
    alterarStatusDoCampoParaSucesso(inputsFormulario, campo, mensagem = null) {
        const opcoesStatus = {
            inputsFormulario: inputsFormulario,
            campo: campo,
            statusValidacao: 'success',
            mensagem: mensagem,
            desabilitarCampo: false
        };
        return alterarStatusValidacaoCampo(opcoesStatus);
    },
    alterarStatusDoCampoParaValidando(inputsFormulario, campo, mensagem) {
        const opcoesStatus = {
            inputsFormulario: inputsFormulario,
            campo: campo,
            statusValidacao: 'validating',
            mensagem: mensagem || 'Validando...',
            desabilitarCampo: true
        };
        return alterarStatusValidacaoCampo(opcoesStatus);
    },
    alterarStatusDoCampoParaErro(inputsFormulario, campo, mensagem) {
        const opcoesStatus = {
            inputsFormulario: inputsFormulario,
            campo: campo,
            statusValidacao: 'error',
            mensagem: mensagem || 'Erro',
            desabilitarCampo: false
        };
        return alterarStatusValidacaoCampo(opcoesStatus);
    }
}

export default FormularioUtils;

function alterarStatusValidacaoCampo(opcoesStatus) {
    let newInputs = [...opcoesStatus.inputsFormulario];
    let campoIndex = newInputs.findIndex(x=>x.input.name == opcoesStatus.campo)
    newInputs[campoIndex] = {...newInputs[campoIndex], input:{
        ...newInputs[campoIndex].input,
        validateStatus: opcoesStatus.statusValidacao,
        help: opcoesStatus.mensagem,
        disabled: opcoesStatus.desabilitarCampo
    }}

    return newInputs;
}